export default __webpack_public_path__ + "static/media/morocco_flag.c2aad6b9.png";